import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const MonitorIcon = createSvgIcon(
  <>
    <path
      d="M9.7251 12.2749C9.7251 12.936 9.98774 13.5701 10.4553 14.0376C10.9228 14.5051 11.5568 14.7678 12.218 14.7678C12.8792 14.7678 13.5132 14.5051 13.9807 14.0376C14.4483 13.5701 14.7109 12.936 14.7109 12.2749C14.7109 11.6137 14.4483 10.9796 13.9807 10.5121C13.5132 10.0446 12.8792 9.78198 12.218 9.78198C11.5568 9.78198 10.9228 10.0446 10.4553 10.5121C9.98774 10.9796 9.7251 11.6137 9.7251 12.2749Z"
      {...strokeProps}
    />
    <path d="M14.0254 10.4675L16.5806 7.91229" {...strokeProps} />
    <path
      d="M5.23793 21C3.41581 19.5517 2.08929 17.5725 1.44221 15.3367C0.795139 13.1009 0.859551 10.7191 1.62652 8.52154C2.39349 6.32396 3.82504 4.41935 5.72278 3.07168C7.62052 1.724 9.89047 1 12.2181 1C14.5456 1 16.8156 1.724 18.7133 3.07168C20.6111 4.41935 22.0426 6.32396 22.8096 8.52154C23.5766 10.7191 23.641 13.1009 22.9939 15.3367C22.3468 17.5725 21.0203 19.5517 19.1982 21H5.23793Z"
      {...strokeProps}
    />
  </>,
  { displayName: 'MonitorIcon', viewBox: '0 0 25 22' }
);
